(() => {
  let searchOpener;
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-ur-search-open]');
    const dialog = document.getElementById('search-modal');
    if (open && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      searchOpener = open;
      dialog.showModal();
      dialog.querySelector('[data-ur-query]').focus();
    }
    if (event.target.closest('[data-ur-search-close]') && dialog) {
      dialog.close();
      searchOpener?.focus();
    }
  });
  function init(root) {
    root.querySelectorAll('[data-ur-search]').forEach(form => {
      if (form.dataset.urReady) return;
      form.dataset.urReady = 'true';
      const input = form.querySelector('[data-ur-query]');
      const scope = form.elements.type;
      const panel = form.querySelector('.ur-search-suggestions');
      const status = form.querySelector('[role=status]');
      let timer, controller, generation = 0;
      function close() {
        clearTimeout(timer);
        generation++;
        controller?.abort();
        panel.hidden = true;
        form.removeAttribute('aria-busy');
        status.textContent = '';
      }
      function fullUrl() {
        const url = new URL(form.action, location.origin);
        url.search = new URLSearchParams(new FormData(form)).toString();
        return url.pathname + url.search;
      }
      async function suggest() {
        controller?.abort();
        const term = input.value.trim();
        const current = ++generation;
        panel.hidden = true;
        if (term.length < 2) { status.textContent = ''; return; }
        controller = new AbortController();
        status.textContent = form.dataset.loading;
        form.setAttribute('aria-busy', 'true');
        try {
          const editorialUrl = new URL(form.dataset.editorialUrl, location.origin);
          editorialUrl.searchParams.set('q', term);
          editorialUrl.searchParams.set('type', 'article');
          editorialUrl.searchParams.set('options[prefix]', 'last');
          editorialUrl.searchParams.set('section_id', 'ur-editorial-suggestions');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) editorialUrl.searchParams.set('preview_theme_id', preview);
          async function editorialItems() {
            const response = await fetch(editorialUrl, {signal: controller.signal});
            if (!response.ok) throw new Error('Suggestions unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (!html.querySelector('[data-ur-editorial-suggestions]')) throw new Error('Editorial suggestions unavailable');
            return [...html.querySelectorAll('[data-ur-editorial-result]')].map(link => ({url: link.getAttribute('href'), title: link.textContent}));
          }
          let data;
          if (scope.value === 'article') {
            data = {resources: {results: {articles: await editorialItems()}}};
          } else {
            const url = new URL(form.dataset.suggestUrl + '.json', location.origin);
            url.searchParams.set('q', term);
            url.searchParams.set('resources[type]', scope.value);
            url.searchParams.set('resources[limit]', '4');
            url.searchParams.set('resources[limit_scope]', 'each');
            const response = await fetch(url, {signal: controller.signal});
            if (!response.ok) throw new Error('Suggestions unavailable');
            data = await response.json();
            if (scope.value.includes('article')) data.resources.results.articles = await editorialItems();
          }
          if (current !== generation) return;
          panel.replaceChildren();
          let count = 0;
          for (const [key, label] of [['articles',form.dataset.magazine],['products',form.dataset.shop],['pages',form.dataset.pages]]) {
            const items = data.resources?.results?.[key] || [];
            if (!items.length) continue;
            const heading = document.createElement('h3');
            heading.textContent = label;
            const list = document.createElement('ul');
            for (const item of items) {
              const target = new URL(item.url, location.origin);
              if (target.origin !== location.origin) continue;
              const li = document.createElement('li'), link = document.createElement('a');
              link.href = target.pathname + target.search;
              link.textContent = item.title;
              li.append(link); list.append(li); count++;
            }
            panel.append(heading, list);
          }
          const all = document.createElement('a');
          all.href = fullUrl(); all.textContent = scope.value === 'article' ? form.dataset.editorialFull : form.dataset.full;
          all.className = 'ur-search-suggestions__all';
          panel.append(all);
          panel.hidden = false;
          status.textContent = count ? form.dataset.count.replace('__COUNT__', count) : form.dataset.none;
          form.removeAttribute('aria-busy');
        } catch (error) {
          if (error.name !== 'AbortError' && current === generation) { status.textContent = form.dataset.unavailable; form.removeAttribute('aria-busy'); }
        }
      }
      input.addEventListener('input', () => { close(); timer = setTimeout(suggest, 250); });
      scope.addEventListener('change', () => { close(); suggest(); });
      form.addEventListener('submit', close);
      form.addEventListener('keydown', event => {
        if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && !panel.hidden) {
          const links = [...panel.querySelectorAll('a')];
          if (links.length) {
            event.preventDefault();
            const index = links.indexOf(document.activeElement);
            const next = event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1);
            links[next].focus();
          }
          return;
        }
        if (event.key !== 'Escape') return;
        const dialog = form.closest('dialog');
        if (!panel.hidden) {
          event.preventDefault(); event.stopPropagation(); close(); input.focus();
        } else if (dialog && dialog.open) {
          event.preventDefault(); event.stopPropagation(); dialog.close(); searchOpener?.focus();
        }
      });
      form.addEventListener('focusout', () => { setTimeout(() => { if (!form.contains(document.activeElement)) close(); }, 0); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

